<template>
    <div class="sa-tab-scroll">
        <b-card class="sa-card" header="Anagrafica" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col v-if="anagraficaRicerca" cols="12" xs="12" sm="6" md="6" lg="4" xl="4">
                    <label class="sa-label-data">Codice Fiscale/STP/ENI*</label>
                    <b-input-group class="mb-3">
                        <b-form-input maxlength="16" class="text-uppercase" v-model="paziente.identificativo" @keypress="onKeyPress"></b-form-input>
                        <b-button size="sm" variant="" @click="onSearchAnagraficaClick"><b-icon icon="search"></b-icon></b-button>
                    </b-input-group>
                </b-col>
                <b-col v-else cols="12" xs="12" sm="6" md="6" lg="4" xl="4">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patients.lblFiscalCode") }}
                        <span style="color: red">*</span>
                    </label>
                    <b-input-group class="mb-3">
                        <!-- <b-form-input maxlength="16" class="text-uppercase" v-model="paziente.codiceFiscale" @keypress="onKeyPress"></b-form-input> -->
                        <b-input-group class="mb-3">
                            <b-form-input maxlength="16" class="text-uppercase" v-model="paziente.identificativo"></b-form-input>
                            <b-button size="sm" variant="" v-b-tooltip.hover title="Check Codice Fiscale" @click="onClickCodiceFiscale(paziente.identificativo)"><b-icon icon="search"></b-icon></b-button>
                        </b-input-group>
                        <!-- <b-button size="sm" variant="" @click="onClick"> <b-icon icon="search"></b-icon> </b-button> -->
                    </b-input-group>
                </b-col>
                <b-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patients.lblLastname") }}
                        <span style="color: red">*</span>
                    </label>
                    <b-form-input v-model="paziente.cognome"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patients.lblName") }}
                        <span style="color: red">*</span>
                    </label>
                    <b-form-input v-model="paziente.nome"></b-form-input>
                </b-col>

                <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patients.lblBirthDate") }}
                        <span style="color: red">*</span>
                    </label>
                    <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="paziente.dataNascita" type="date"></date-picker>
                </b-col>
                <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patients.lblGender") }}
                        <span style="color: red">*</span>
                    </label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="paziente.sesso" class="mb-2 mr-sm-2 mb-sm-0" :options="sessoOption" :value="null">
                        <template #first>
                            <b-form-select-option :value="null" disabled>{{ selectOptionSesso }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <!-- <b-col cols="12" xs="12" sm="6" md="6" lg="4" xl="4">
                    <label class="sa-label-data">{{ this.$i18n.t("patients.lblBloodGroup") }}</label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="paziente.gruppoSanguigno" class="mb-2 mr-sm-2 mb-sm-0" :value="null" :options="gruppoSanguignoOption">
                        <template #first>
                            <b-form-select-option :value="null" disabled>{{ selectOptionGruppoSanguigno }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col> -->
                <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patients.lblProvince") }}
                        <span style="color: red">*</span>
                    </label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="paziente.provinciaNascita" class="mb-2 mr-sm-2 mb-sm-0" :options="provinciaNascitaOption" :value="null" @change="loadComuneNascita(paziente.provinciaNascita)">
                        <b-form-select-option :value="null" disabled>{{ selectOptionProvincia }}</b-form-select-option>
                    </b-form-select>
                </b-col>
                <b-col v-if="nazionalitaNascita" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                    <label class="sa-label-data">
                        Nazionalità
                        <span style="color: red">*</span>
                    </label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="paziente.comuneNascitaCodiceIstat" class="mb-2 mr-sm-2 mb-sm-0" :options="comuneNascitaOption" :value="null" value-field="codiceIstat" text-field="comune"></b-form-select>
                </b-col>
                <b-col v-if="!nazionalitaNascita" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patients.lblCity") }}
                        <span style="color: red">*</span>
                    </label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="paziente.comuneNascitaCodiceIstat" class="mb-2 mr-sm-2 mb-sm-0" :options="comuneNascitaOption" :value="null" value-field="codiceIstat" text-field="comune"></b-form-select>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="Residenza" header-tag="header" footer-tag="footer" title="" v-if="tipoAnagrafica === 'completa'">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">{{ this.$i18n.t("patients.lblProvince") }}<span style="color: red">*</span></label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="paziente.provinciaResidenza" class="mb-2 mr-sm-2 mb-sm-0" :options="provinciaResidenzaOption" :value="null" @change="loadComuneResidenza(paziente.provinciaResidenza)">
                        <template #first>
                            <b-form-select-option :value="null" disabled>{{ selectOptionProvincia }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col v-if="nazionalitaResidenza" cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">
                        Nazionalità
                        <span style="color: red">*</span>
                    </label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="paziente.comuneResidenzaCodiceIstat" class="mb-2 mr-sm-2 mb-sm-0" :options="comuneResidenzaOption" :value="null" value-field="codiceIstat" text-field="comune" @change="setCapResidenza"></b-form-select>
                </b-col>
                <b-col v-if="!nazionalitaResidenza" cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patients.lblCity") }}
                        <span style="color: red">*</span>
                    </label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="paziente.comuneResidenzaCodiceIstat" class="mb-2 mr-sm-2 mb-sm-0" :options="comuneResidenzaOption" :value="null" value-field="codiceIstat" text-field="comune" @change="setCapResidenza"></b-form-select>
                </b-col>

                <!-- <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">{{ this.$i18n.t("patients.lblCity") }}<span style="color: red">*</span></label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="paziente.comuneResidenzaCodiceIstat" class="mb-2 mr-sm-2 mb-sm-0" :options="comuneResidenzaOption" :value="null" value-field="codiceIstat" text-field="comune" @change="setCapResidenza">
                        <template #first>
                            <b-form-select-option :value="null" disabled>{{ selectOptionComune }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col> -->
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data"> {{ this.$i18n.t("patients.lblPostalCode") }}<span style="color: red">*</span></label>
                    <b-form-input v-model="paziente.capResidenza"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">{{ this.$i18n.t("patients.lblAddress") }}<span style="color: red">*</span></label>
                    <b-form-input v-model="paziente.indirizzoResidenza" @change="onChangeIndirizzoResidenza"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <b-form-checkbox v-model="isDomicilioUgualeResidenza" name="check-button" switch>
                        <h5 class="sa-text-left domicilio-residenza-checkbox">{{ this.$i18n.t("patient.lblIsDomicilioEqualResidenza") }}</h5>
                    </b-form-checkbox>
                </b-col>
            </b-row>
        </b-card>
        <b-card v-if="!isDomicilioUgualeResidenza && tipoAnagrafica === 'completa'" class="sa-card" header="Domicilio" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patients.lblProvince") }}
                        <span style="color: red">*</span>
                    </label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="paziente.provinciaDomicilio" class="mb-2 mr-sm-2 mb-sm-0" :options="provinciaDomicilioOption" @change="loadComuneDomicilio(paziente.provinciaDomicilio)">
                        <template #first>
                            <b-form-select-option :value="null" disabled>{{ selectOptionProvincia }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patients.lblCity") }}
                        <span style="color: red">*</span>
                    </label>
                    <b-form-select id="inline-form-custom-select-pref" v-model="paziente.comuneDomicilioCodiceIstat" class="mb-2 mr-sm-2 mb-sm-0" :options="comuneDomicilioOption" :value="null" value-field="codiceIstat" text-field="comune" @change="setCapDomicilio">
                        <template #first>
                            <b-form-select-option :value="null" disabled>{{ selectOptionComune }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patients.lblPostalCode") }}
                        <span style="color: red">*</span>
                    </label>
                    <b-form-input v-model="paziente.capDomicilio"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patients.lblAddress") }}
                        <span style="color: red">*</span>
                    </label>
                    <b-form-input v-model="paziente.indirizzoDomicilio"></b-form-input>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="Contatti" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patients.lblTelephoneNumber") }}
                        <span style="color: red">*</span>
                    </label>
                    <b-form-input v-model="paziente.telefono"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                    <label class="sa-label-data">
                        {{ this.$i18n.t("patients.lblEmail") }}
                        <span style="color: red">*</span>
                    </label>
                    <b-form-input v-model="paziente.email"></b-form-input>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">{{ this.$i18n.t("patients.lblNote") }}</label>
                    <b-form-textarea v-model="paziente.note" no-resize rows="6"></b-form-textarea>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    mixins: [UtilityMixin],
    components: { DatePicker },
    props: {
        paziente: {
            Type: Object,
            default: function () {
                return {
                    cognome: "",
                    nome: "",
                    identificativo: "",
                    indirizzoResidenza: "",
                    indirizzoDomicilio: "",
                    note: "",
                    regioneNascita: null,
                    regioneResidenza: null,
                    regioneDomicilio: null,
                    sesso: null,
                    comuneDomicilioCodiceIstat: null,
                    provinciaDomicilio: null,
                    comuneNascitaCodiceIstat: null,
                    provinciaNascita: null,
                    comuneResidenzaCodiceIstat: null,
                    provinciaResidenza: null,
                    capResidenza: null,
                    capDomicilio: null,
                    gruppoSanguigno: null,
                    telefono: "",
                    email: "",
                };
            },
        },
    },
    watch: {
        paziente: {
            handler(paziente) {
                this.$emit("update", paziente);
            },
            deep: true,
        },
        isDomicilioUgualeResidenza(value) {
            let me = this;
            if (value) {
                me.paziente.indirizzoDomicilio = me.paziente.indirizzoResidenza;
                me.paziente.comuneDomicilioCodiceIstat = me.paziente.comuneResidenzaCodiceIstat;
                me.paziente.provinciaDomicilio = me.paziente.provinciaResidenza;
                me.paziente.capDomicilio = me.paziente.capResidenza;
                // console.log(me.data);
            } else if (!value) {
                (me.paziente.indirizzoDomicilio = null), (me.paziente.comuneDomicilioCodiceIstat = null), (me.paziente.provinciaDomicilio = null), (me.paziente.capDomicilio = null);
            }
        },
    },
    data() {
        return {
            stateIdentificativo: false,
            selectOptionGruppoSanguigno: this.$i18n.t("patients.selectGruopBlood"),
            selectOptionRegione: this.$i18n.t("patients.selectRegions"),
            selectOptionSesso: this.$i18n.t("patients.selectGender"),
            selectOptionComune: this.$i18n.t("patients.selectCounties"),
            selectOptionProvincia: this.$i18n.t("patients.selectCity"),
            pathResource: "/pazienti",
            linkProvince: "/province",
            pathResourceRegioni: "/regioni",
            linkComune: "/comuni/provincia",
            linkNazionalita: "/nazionalita",
            linkComuneByIstat: "/comuni/istat",
            linkGruppiSangue: "/pazientigruppisanguigno",
            pathResourcePazienti: "/pazienti",
            profili: [],
            sessoOption: [],
            codiceFiscaleValido: false,
            regioniOptions: [],
            tipoAnagrafica: "completa",
            anagraficaRicerca: false,
            nazionalitaNascita: false,
            nazionalitaResidenza: false,
            isDomicilioUgualeResidenza: true,
            provinciaNascitaOption: [],
            anagraficaInfo: {},
            provinciaDomicilioOption: [],
            provinciaResidenzaOption: [],
            comuneNascitaOption: [],
            comuneDomicilioOption: [],
            comuneResidenzaOption: [],
            language: null,
            gruppoSanguignoOption: [],
            identificationDimension: 0,
        };
    },
    mounted: function () {
        let me = this;
        me.identificationDimension = this.appConfig.identificationDimension;
        me.tipoAnagrafica = this.appConfig.tipoAnagrafica;
        me.anagraficaRicerca = this.appConfig.anagraficaRicerca;
        // me.id = this.$route.params.id;
        // me.language = this.$route.query.language;
        me.loadDefaultData();
    },
    methods: {
        loadDefaultData() {
            let me = this;
            me.loadProvinceNascita();
            me.loadProvinceDomicilio();
            me.loadProvinceResidenza();
            me.loadRegioni();
            me.loadGruppiSangue();
            me.loadSesso();
            me.loadData();
        },
        onDataChange(input, id) {
            let me = this;
            me.checkState(input, id);
        },
        checkState(input, id) {
            console.log(typeof input);
            if (typeof input == "number") {
                document.getElementById(id).classList.remove("red-border");
                document.getElementById(id).classList.add("green-border");
            } else {
                document.getElementById(id).classList.remove("green-border");
                document.getElementById(id).classList.add("red-border");
            }
        },
        loadSesso() {
            let link = process.env.VUE_APP_PATH_API + "/anagraficasesso";
            axios.get(link).then((res) => {
                let sessi = res.data.data;
                sessi.forEach((element) => {
                    let obj = { value: element.codice, text: this.$i18n.t(element.descrizione) };
                    this.sessoOption.push(obj);
                });
            });
        },
        loadData() {
            let me = this;
            if (me.paziente.id !== null) {
                me.showModalLoading = true;
                let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
                axios
                    .get(link + me.paziente.id)
                    .then((response) => {
                        this.$emit("update", response.data.data);
                        me.loadComuneNascita(me.paziente.provinciaNascita);
                        me.loadComuneResidenza(me.paziente.provinciaResidenza);
                        me.loadComuneDomicilio(me.paziente.provinciaDomicilio);
                        me.showModalLoading = false;
                        me.validazioneIdentificativo(me.paziente.identificativo);
                        me.checkState(me.paziente.dataNascita, "date-picker-1");
                    })
                    .catch(() => {});
            } else {
                me.loadComuneNascita(me.paziente.provinciaNascita);
                me.loadComuneResidenza(me.paziente.provinciaResidenza);
                me.loadComuneDomicilio(me.paziente.provinciaDomicilio);
            }
        },
        loadRegioni() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceRegioni;
            axios.get(link).then((response) => {
                me.regioniOptions = response.data.data;
            });
        },
        loadProvinceNascita() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.linkProvince;
            axios.get(link).then((response) => {
                response.data.data.forEach((element) => {
                    me.provinciaNascitaOption.push({ value: element.sigla, text: element.provincia });
                });
            });
        },
        loadGruppiSangue() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.linkGruppiSangue;
            axios.get(link).then((response) => {
                response.data.data.forEach((element) => {
                    me.gruppoSanguignoOption.push({ value: element.descrizione, text: this.$i18n.t(element.descrizione) });
                });
            });
        },
        loadProvinceDomicilio() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.linkProvince;
            axios.get(link).then((response) => {
                response.data.data.forEach((element) => {
                    me.provinciaDomicilioOption.push({ value: element.sigla, text: element.provincia });
                });
            });
        },
        loadProvinceResidenza() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.linkProvince;
            axios.get(link).then((response) => {
                response.data.data.forEach((element) => {
                    me.provinciaResidenzaOption.push({ value: element.sigla, text: element.provincia });
                });
            });
        },
        loadComuneNascita(sigla) {
            // let me = this;
            // let link = process.env.VUE_APP_PATH_API + me.linkComune + "/" + sigla;
            // axios.get(link).then((response) => {
            //   me.comuneNascitaOption = [];
            //   response.data.data.forEach((element) => {
            //     me.comuneNascitaOption.push({ value: element.codiceIstat, text: element.comune });
            //   });
            // });
            let me = this;
            me.nazionalitaNascita = false;
            if (sigla === "EE") {
                me.nazionalitaNascita = true;
                let link = process.env.VUE_APP_PATH_API + me.linkNazionalita;
                me.comuneNascitaOption = [];
                axios.get(link).then((response) => {
                    response.data.data.list.forEach((element) => {
                        let nazionalita = { comune: element.cittadinanza + " - (" + element.denominazione + ")", provincia: "EE", cap: "0", codiceIstat: element.istatStato, codiceCatastale: element.codiceCatastale };
                        me.comuneNascitaOption.push(nazionalita);
                    });

                    me.comuneNascitaOption.unshift({ codiceIstat: null, comune: "-Seleziona Valore-" });
                });
            } else {
                let link = process.env.VUE_APP_PATH_API + me.linkComune + "/" + sigla;
                me.comuneNascitaOption = [];
                axios.get(link).then((response) => {
                    me.comuneNascitaOption = [];
                    // response.data.data.forEach((element) => {
                    //     me.comuneNascitaOption.push({ value: element.codiceIstat, text: element.comune });
                    // });
                    me.comuneNascitaOption = response.data.data;
                    me.comuneNascitaOption.unshift({ codiceIstat: null, comune: "-Seleziona Valore-" });
                });
            }
        },
        loadComuneDomicilio(sigla) {
            // let me = this;
            // let link = process.env.VUE_APP_PATH_API + me.linkComune + "/" + sigla;
            // axios.get(link).then((response) => {
            //     me.comuneDomicilioOption = response.data.data;
            //     me.comuneDomicilioOption.unshift({ codiceIstat: null, comune: "- Seleziona Comune -" });

            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.linkComune + "/" + sigla;
            axios.get(link).then((response) => {
                me.comuneDomicilioOption = response.data.data;
            });
        },
        setCapDomicilio(item) {
            let me = this;
            me.comuneDomicilioOption.forEach((comuneDomicilio) => {
                if (comuneDomicilio.codiceIstat === item) {
                    me.paziente.capDomicilio = comuneDomicilio.cap;
                }
            });
        },
        loadComuneResidenza(sigla) {
            let me = this;
            me.paziente.provinciaDomicilio = me.paziente.provinciaResidenza;
            console.log("Eccomi");

            me.nazionalitaResidenza = false;
            if (sigla === "EE") {
                me.nazionalitaResidenza = true;
                let link = process.env.VUE_APP_PATH_API + me.linkNazionalita;
                me.comuneResidenzaOption = [];
                axios.get(link).then((response) => {
                    response.data.data.list.forEach((element) => {
                        let nazionalita = { comune: element.cittadinanza + " - (" + element.denominazione + ")", provincia: "EE", cap: "0", codiceIstat: element.istatStato, codiceCatastale: element.codiceCatastale };
                        me.comuneResidenzaOption.push(nazionalita);
                    });
                    me.comuneResidenzaOption.unshift({ codiceIstat: null, comune: "-Seleziona Valore-" });
                });
            } else {
                // let link = process.env.VUE_APP_PATH_API + me.linkComune + "/" + sigla;
                me.comuneResidenzaOption = [];
                let link = process.env.VUE_APP_PATH_API + me.linkComune + "/" + sigla;
                axios.get(link).then((response) => {
                    me.comuneResidenzaOption = response.data.data;
                    me.setCapResidenza(me.paziente.comuneResidenzaCodiceIstat);
                });
            }

            // let link = process.env.VUE_APP_PATH_API + me.linkComune + "/" + sigla;
            // axios.get(link).then((response) => {
            //     me.comuneResidenzaOption = response.data.data;
            //     me.setCapResidenza(me.paziente.comuneResidenzaCodiceIstat);
            // });
        },
        setCapResidenza(value) {
            let me = this;
            me.paziente.comuneDomicilioCodiceIstat = me.paziente.comuneResidenzaCodiceIstat;
            console.log(me.paziente.comuneResidenzaCodiceIstat);
            me.comuneResidenzaOption.forEach((comuneResidenza) => {
                if (comuneResidenza.codiceIstat === value) {
                    me.paziente.capResidenza = comuneResidenza.cap;
                    me.paziente.capDomicilio = me.paziente.capResidenza;
                }
            });
        },
        onValidazioneIdentificativo(value) {
            let me = this;
            me.validazioneIdentificativo(value);
        },
        validazioneIdentificativo(value) {
            let me = this;
            if (value.length != me.identificationDimension) {
                me.stateIdentificativo = false;
                return;
            }
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + "/anagrafica/validazioneidentificativo?identificativo=" + value;
            axios
                .get(link)
                .then(() => {
                    // me.btnSaveVisible = true;
                    me.stateIdentificativo = true;
                    me.showModalLoading = false;
                })
                .catch(() => {
                    // me.btnSaveVisible = false;
                    me.stateIdentificativo = false;
                    me.showModalLoading = false;
                });
        },
        onKeyPress(e) {
            let me = this;
            if (e.keyCode === 13) {
                me.searchAnagrafica();
            }
        },
        onSearchAnagraficaClick() {
            let me = this;
            me.searchAnagrafica();
        },
        searchAnagrafica() {
            let me = this;
            me.showmolalloading = true;
            if (me.paziente.identificativo.trim().length === 0) {
                me.showmolalloading = false;
            } else {
                me.paziente.identificativo = me.paziente.identificativo.toUpperCase();
                let link = process.env.VUE_APP_PATH_API + "/utility";
                axios
                    .get(link, {
                        params: { codiceFiscale: me.paziente.identificativo },
                    })
                    .then((response) => {
                        me.paziente.nome = response.data.data.nome;
                        me.paziente.cognome = response.data.data.cognome;
                        me.paziente.dataNascita = moment(response.data.data.dataNascita, "DD/MM/YYYY").toDate().getTime();
                        me.paziente.sesso = response.data.data.sesso;
                        me.paziente.provinciaNascita = response.data.data.provinciaNascita;
                        me.paziente.regioneResidenza = response.data.data.regioneResidenza;
                        me.paziente.comuneNascitaCodiceIstat = response.data.data.codiceIstatComuneNascita;
                        me.paziente.provinciaResidenza = response.data.data.provinciaResidenza;
                        me.paziente.comuneResidenzaCodiceIstat = response.data.data.codiceIstatComuneResidenza;
                        me.loadComuneNascita(me.paziente.provinciaNascita);
                        me.loadComuneResidenza(me.paziente.provinciaResidenza);
                        me.loadComuneDomicilio(me.paziente.provinciaDomicilio);
                        me.paziente.indirizzoResidenza = response.data.data.indirizzoResidenza;
                        me.paziente.codiceFiscaleMedicoCurante = response.data.data.codiceFiscaleMedico;
                        me.paziente.medicoCurante = response.data.data.medico;

                        me.showmolalloading = false;
                    })
                    .catch(() => {
                        me.showmolalloading = false;
                    });
            }
        },

        onClickCodiceFiscale(value) {
            let me = this;
            let path = process.env.VUE_APP_PATH_API + me.pathResourcePazienti + "/identificativo/" + value.trim();
            UtilityMixin.methods.restCallGet(path, null, me.checkPresentAnagraficaSuccess, me.checkPresentAnagraficaError);
        },
        checkPresentAnagraficaSuccess(response) {
            let me = this;
            me.$emit("update", response.data.data);
        },
        checkPresentAnagraficaError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            let value = me.paziente.identificativo;
            if (value) {
                value = value.trim();
                var regexCodiceFiscale = /^(?:(?:[B-DF-HJ-NP-TV-Z]|[AEIOU])[AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/;
                // console.log(regexCodiceFiscale.test(value.toUpperCase()));
                if (regexCodiceFiscale.test(value.toUpperCase())) {
                    this.codiceFiscaleValido = true;
                } else {
                    this.codiceFiscaleValido = false;
                }
                const codice = value;
                me.paziente.identificativo = codice;
                me.checkCodiceFiscale(me.paziente.identificativo.toUpperCase());
            } else {
                me.$bvToast.toast("Inserire Codice Fiscale", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        checkCodiceFiscale(codiceFiscale) {
            let me = this;
            if (me.codiceFiscaleValido) {
                let path = "/utilityanagrafica/codicefiscale";
                me.loadDataResources(path, { codiceFiscale: codiceFiscale }, me.resultResponseCodiceFiscale, me.resultErrorCodiceFiscale);
            } else {
                me.$bvToast.toast("Codice Fiscale non corretto", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        resultResponseCodiceFiscale(response) {
            let me = this;
            me.anagraficaInfo = response.data.data;
            me.paziente.dataNascita = me.anagraficaInfo.dataNascita;
            me.paziente.sesso = me.anagraficaInfo.sesso;
            me.paziente.comuneNascitaCodiceIstat = me.anagraficaInfo.comuneNascitaCodiceIstat;
            me.paziente.provinciaNascita = me.anagraficaInfo.provinciaNascita;
            me.loadComuni(me.paziente.provinciaNascita, "nascita");
        },
        resultErrorCodiceFiscale(error) {
            let me = this;
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "";
            me.$bvToast.toast("Errore durante il caricamento: " + messaggio, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        loadComuni(sigla, destination) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.linkComune + "/" + sigla;
            axios
                .get(link)
                .then((response) => {
                    response.data.data.forEach((comune) => {
                        switch (destination) {
                            case "nascita":
                                me.comuneNascitaOption.push(comune);
                                break;
                            case "residenza":
                                me.comuneResidenzaOption.push(comune);
                                break;
                            case "domicilio":
                                me.comuneDomicilioOption.push(comune);
                                break;
                        }
                    });
                })
                .catch((error) => {
                    console.log("Il servizio delle province ha datao errore: " + error.response.status);
                });
        },
        onChangeIndirizzoResidenza() {
            let me = this;
            me.paziente.indirizzoDomicilio = me.paziente.indirizzoResidenza;
        },
    },
};
</script>

<style></style>
